import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../views/layout/index.vue'

Vue.use(VueRouter)
import InformationCenter from './module/ay-information-center' // 示例
import AccountManager from './module/ay-account-manager' // 账户管理
import Aybusinessinquiry from './module/ay-business-inquiry' //业务管理
import ayPersonalCenter from './module/ay-personal-center' // 个人中心


export const constantRoutes = [
    {
        path: '/login',
        component: () => import('@/views/login/index'),
        meta: {title: '登录'},
        hidden: true
    },
    {
        path: '/pay/return-page',
        component: () => import('@/views/pay/index'),
        meta: {title: '支付结果'},
        hidden: true
    },
    {
        path: '/404',
        component: () => import('@/views/error-page/404'),
        meta: {title: '404 Page Not Found'},
        hidden: true
    },
    {
        path: '/',
        component: Layout,
        redirect: '/index',
        children: [
            {
                path: 'index',
                component: () => import('@/views/home/index'),
                name: 'Home',
                meta: {title: 'button.homepage'}  //首页
            }
        ]
    },
    {
        path: '/',
        component: Layout,
        meta: {title: 'poOrder.type.new.member'}, // 经销商注册(未登录)
        hidden: true,
        children: [
            {
                path: '/inRegister',
                component: () => import('@/views/in-register/index'),
                name: 'InRegister',
                hidden: true
            },
            {
                path: '/inRegisterSuccess',
                component: () => import('@/views/in-register/register-success'),
                name: 'RegisterSuccess',
                hidden: true
            }
        ]
    }
]

export const asyncRoutes = [
    ...InformationCenter,
    ...AccountManager,
    ...Aybusinessinquiry,
    ...ayPersonalCenter
]

const createRouter = () => new VueRouter({
    scrollBehavior: () => ({y: 0}),
    routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export default router
